import { render, staticRenderFns } from "./SdfForm.vue?vue&type=template&id=3877fe78&"
import script from "./SdfForm.vue?vue&type=script&lang=js&"
export * from "./SdfForm.vue?vue&type=script&lang=js&"
import style0 from "./SdfForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports